<template>
  <el-container class="app-wrapper">
    <!-- 侧边栏 -->
    <el-aside :width="sidebarCollapsed ? '64px' : '210px'" class="sidebar-container">
      <Sidebar />
    </el-aside>

    <el-container class="main-container">
      <!-- 顶部导航栏 -->
      <el-header class="navbar" height="50px">
        <Navbar />
      </el-header>

      <!-- 内容区域 -->
      <el-main class="app-main">
        <transition name="fade" mode="out-in">
          <router-view :key="$route.path" />
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapState } from 'vuex'
import Sidebar from './Sidebar/index.vue'
import Navbar from './Navbar.vue'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    Navbar
  },
  computed: {
    ...mapState('app', ['sidebarCollapsed'])
  }
}
</script>

<style lang="less" scoped>
.app-wrapper {
  height: 100%;
  width: 100%;
}

.sidebar-container {
  background: @sidebar-bg;
  transition: width 0.28s;
  overflow: hidden;
}

.main-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.navbar {
  background: @bg-white;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 0;
  display: flex;
  align-items: center;
}

.app-main {
  background: @bg-color;
  padding: @spacing-medium;
  overflow-y: auto;
}
</style>
